import { styled } from 'styled-components';
import { dontForwardProps } from '../../util';
export const Label = styled.label.withConfig(dontForwardProps()).withConfig({
  displayName: "Label",
  componentId: "asurion-ui-react__sc-1nr9yx9-0"
})(["display:inline-flex;align-items:", ";box-sizing:border-box;position:relative;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;"], ({
  multiline
}) => multiline ? 'flex-start' : 'center');